export enum UserRoleALert {
  Administrator = 'c6c78df9-00a0-4f67-9f04-7b3bc53f28b0',
  Analyst = '286e7f7d-a4d4-4fee-b0fe-7e466c98824a',
}
